import { Button, ButtonVariant, Intent, Tag, Tooltip } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { __ } from "src/libs/utilities"
import { LANDING_EDIT_MODE, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, useLandingConsoleStore, } from "src/modules/pe-landing-module/data/store"
import useSelectedContent from "src/modules/pe-landing-module/hooks/useSelectedContent"
import { setCursor } from "."
import transform_tool from "../../../../assets/img/transform-tool.svg"

/* Protopia Ecosystem component */
export interface IDragToolProps {
   
}
const TransformTool = (props: IDragToolProps): JSX.Element => {
    const editMode      = useLandingConsoleStore((state: ILandingConsoleStore) => state.editMode)
    const [isEnabled, setIsEnabled] = useState<boolean>(false)
    const selectedData  = useSelectedContent()
    
    useEffect(() => { 
        setIsEnabled( selectedData?.type !== SELECT_TYPE.NONE)
    }, [ selectedData ])

    const setEdit = () => {
        useLandingConsoleStore.setState({ editMode: LANDING_EDIT_MODE.TRANSFORM })
        setCursor("default")
    }
    const isEdit = editMode === LANDING_EDIT_MODE.TRANSFORM

    return <Tooltip 
        content={ <div className="small letter-spacing-1 flex-centered"> 
            <div className="button-label">{ __( "Transform" ) }</div>
            <Tag minimal className="ml-2 px-2 py-0"><div className="smallest text-light title">CTRL + P</div></Tag>
        </div> } 
        intent={Intent.PRIMARY}
        className=" ml-auto" 
        position="right"
        compact
        hoverOpenDelay={600}
        portalClassName="z-index-90"
        modifiers={{ 
            arrow: { enabled: true },
            flip: { enabled: true },
            preventOverflow: { enabled: false },
            offset: { 
                enabled: true, 
                options: {
                    offset: [0, 2],
                } 
            }, 
        }}
    >
        <Button variant={ isEdit ? ButtonVariant.SOLID : ButtonVariant.MINIMAL} onClick={ setEdit } disabled={!isEnabled}>
            <div className={`d-flex flex-column align-items-center ${isEdit ? "" : "opacity_5"}`}>
                <img src={transform_tool} alt="" height={15} className="panel-icon" /> 
            </div>
        </Button>
    </Tooltip>
}
export default TransformTool